export const getPackageIDList = (packages: any) => {
  let packageIDList: any = [];

  packages.map((p: any) => {
    p.packageIDs.map((p_id: number) => {
      packageIDList.push(p_id);
      return p_id;
    });
    return p;
  });

  const uniqPackageIDList = [...new Set(packageIDList)];

  return uniqPackageIDList;
};